<app-simulation-select [selectedSimu]="simuCode"></app-simulation-select>

<app-invest-simulation></app-invest-simulation>
<app-invest-projects></app-invest-projects>

<app-invest-eval></app-invest-eval>
